/* Spotlight: the packshot follows the colour picked under it. */
(function () {
  function section(el) { return el.closest('section'); }
  document.addEventListener('click', function (event) {
    var sw = event.target.closest('halo-spot-buy [data-halo-colour]');
    if (!sw) return;
    var root = section(sw);
    if (!root) return;
    var imgs = Array.prototype.slice.call(root.querySelectorAll('[data-spot-img]'));
    var target = imgs.filter(function (img) { return img.getAttribute('data-spot-img') === sw.getAttribute('data-halo-colour'); })[0];
    if (!target) return;
    target.loading = 'eager';
    imgs.forEach(function (img) { img.hidden = img !== target; });
  });
  function preload(event) {
    var buy = event.target.closest && event.target.closest('halo-spot-buy');
    if (!buy || buy.dataset.preloaded) return;
    buy.dataset.preloaded = '1';
    var root = section(buy);
    if (root) root.querySelectorAll('[data-spot-img]').forEach(function (img) { img.loading = 'eager'; });
  }
  document.addEventListener('pointerover', preload, { passive: true });
  document.addEventListener('touchstart', preload, { passive: true });
})();
